function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M413.681 293.097v7.421h-59.363v-7.421h-22.26v29.682h14.841v7.419h74.202v-7.419h14.841v-29.682z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M332.058 181.793v81.623c0 39.759 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-81.623H332.058z",
  fill: "#338af3"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M383.997 242.675c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873zm0-41.59c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873z",
  fill: "#f3f3f3"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.827v40.827h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M155.826 200.344L256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
  fill: "#d80027"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M100.174 140.982L0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
  fill: "#d80027"
});

const SvgFalklandIslands = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFalklandIslands, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/falkland-islands.295b1577.svg";
export { ForwardRef as ReactComponent };